// BASE
export const TM_BASE_ENDPOINT = `${process.env.REACT_APP_TASKS_MANAGEMENT_SERVICE_BASE_URL}${process.env.REACT_APP_TASKS_MANAGEMENT_SERVICE_PORT}/${process.env.REACT_APP_TASKS_MANAGEMENT_SERVICE_NAME}/${process.env.REACT_APP_TASKS_MANAGEMENT_SERVICE_URL_TYPE}/${process.env.REACT_APP_TASKS_MANAGEMENT_SERVICE_VERSION}/${process.env.REACT_APP_TASKS_MANAGEMENT_SERVICE_TYPE}`;

export const TASKS = "tasks";
export const SUB_TASKS = "subtasks";
export const OWN_TASKS = "my-tasks";
export const SHARED_TASKS = "shared-tasks";
export const ASSIGNED_TASKS = "assigned-tasks";
export const ASSIGNED_SUB_TASKS = "subtasks/assigned-subtasks";
export const SHARED_SUB_TASKS = "subtasks/shared";
export const SETTINGS = "settings";
export const PRIORITY = "priorities";
export const STATUS = "statuses";

// ALL TASKS
export const ALL_TASKS_ENDPOINT = `${TM_BASE_ENDPOINT}/${TASKS}`;

// SUB TASKS
export const SUB_TASKS_ENDPOINT = `${TM_BASE_ENDPOINT}/${TASKS}`;

// OWN/MY TASKS
export const OWN_TASKS_ENDPOINT = `${TM_BASE_ENDPOINT}/${TASKS}/${OWN_TASKS}`;

// SHARED TASKS
export const SHARED_TASKS_ENDPOINT = `${TM_BASE_ENDPOINT}/${TASKS}/${SHARED_TASKS}`;

// ASSIGNED TASKS
export const ASSIGNED_TASKS_ENDPOINT = `${TM_BASE_ENDPOINT}/${TASKS}/${ASSIGNED_TASKS}`;

// ASSIGNED SUB TASKS
export const ASSIGNED_SUB_TASKS_ENDPOINT = `${TM_BASE_ENDPOINT}/${ASSIGNED_SUB_TASKS}`;

// SHARED SUB TASKS
export const SHARED_SUB_TASKS_ENDPOINT = `${TM_BASE_ENDPOINT}/${SHARED_SUB_TASKS}`;

// SETTINGS PRIORITY
export const SETTINGS_PRIORITY_ENDPOINT = `${TM_BASE_ENDPOINT}/${SETTINGS}/${PRIORITY}`;

// SETTINGS STATUS
export const SETTINGS_STATUS_ENDPOINT = `${TM_BASE_ENDPOINT}/${SETTINGS}/${STATUS}`;
